import { showMessageByType } from './show-message-by-type';
import { POST_REVERTED_TO_DRAFT } from '../components/message/messages';
import { setIsLoading } from './set-is-loading';
import { push } from '../services/router-utils';
import { PATH_ROOT } from '../../business-manager-old/constants/routes/paths';
import { normalizePost } from '../services/post-utils';
import { getCategoryIds } from '../selectors/categories-selectors';
import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';
import { updatePostSuccess } from './update-post';

export const REVERT_TO_DRAFT_SUCCESS = 'post/REVERT_TO_DRAFT_SUCCESS';

export const revertPostToDraftSuccess = createAction(REVERT_TO_DRAFT_SUCCESS);

export const revertPostToDraft = postId => (dispatch, getState, { request }) => {
  if (!postId) {
    return Promise.resolve();
  }

  dispatch(setIsLoading('revertToDraft', undefined, true));

  return request
    .post(`/_api/posts/${postId}/unpublish`)
    .then(post => {
      const normalizedPost = normalizePost({ post, blogCategoryIds: getCategoryIds(getState()) });
      dispatch(revertPostToDraftSuccess(normalizedPost));
      dispatch(updatePostSuccess(normalizedPost));
    })
    .then(() => dispatch(push(PATH_ROOT)))
    .then(() => dispatch(setIsLoading('revertToDraft', undefined, false)))
    .then(() => dispatch(showMessageByType(POST_REVERTED_TO_DRAFT)))
    .catch(() => dispatch(setIsLoading('revertToDraft', undefined, false)));
};
